export default function BannedUserErrorPage() {
  return (
    <section>
      <div className="h-screen w-screen bg-gray-100">
        <div className="h-full w-full">
          <div className="flex flex-col justify-center items-center h-full w-full">
            <div className="flex flex-col justify-center items-center">
              <img src="/vibrato-logo-alt.svg" className="h-[80px] min-w-fit mb-8" />
              {/* Updated error message for banned users */}
              <div className="text-4xl font-bold text-gray-700">Account Suspended</div>
              <div className="text-2xl font-normal text-gray-700 mt-4 max-w-md text-center">
                Your account has been suspended due to a violation of our{" "}
                <a className="text-blue-500 hover:underline" href="/terms-of-service">
                  terms of service.
                </a>
              </div>
              <div className="text-2xl font-normal text-gray-700 mt-4 max-w-md text-center">
                If you believe this is an error, please contact our support team at{" "}
                <a href="mailto:contact@getvibrato.com" className="text-blue-500 hover:underline">
                  contact@getvibrato.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
